import React, { Component } from "react";
import ElectronicVerification from "@formatic/electronic-verification";
import AbnLookupComponent from "@formatic/abn-lookup";
import ProfileLookupComponent from "@formatic/profile-lookup";
import { Overrides } from "@formatic/sdk";

import OneRegistryLayout from "../../layouts/OneRegistry";
import Formatic from "../../components/Formatic";
import { ParamsFromURL } from "../../components/common";

import "@formatic/electronic-verification/dist/bundle.css";
import logo from "../../layouts/OneRegistry/img/logo-cvc.png";

let params;
const formProps = {
  apiServerUrl: "https://api.transformd.com",
  serverUrl: "https://api.transformd.com/graphql",
  subscriptionServerUrl: "wss://api.transformd.com/subscriptions",
  environment: "Live",
  channel: "master",
  apiKey: "5ba102bED0f1d20a61CAE103aD4e69a6Cb1D3225B0D8aA7c3295adE21291daf6",
};

class Form3Route extends Component {
  constructor(props) {
    super(props);

    params = ParamsFromURL(props.location.search);
  }

  componentDidMount() {
    document.title = "CVC Emerging Companies Fund II";
  }

  render() {
    return (
      <OneRegistryLayout formName="CVC Emerging Companies Fund II" logo={logo}>
        <div className="formatic-save-loading">
          <span>Saved</span>
        </div>
        <div className="page__example-fsf form-650">
          <Formatic
            {...formProps}
            formId={770}
            config="default"
            submissionId={params.sessionId}
            theme="transformd"
            runReduxDevTools={process.env.NODE_ENV === "development"}
          >
            <Overrides.OverrideFieldContainer type="electronicVerification" component={ElectronicVerification} />
            <Overrides.OverrideFieldContainer component={AbnLookupComponent} type="abnLookup" />
            <Overrides.OverrideFieldContainer component={ProfileLookupComponent} type="profileLookup" />
          </Formatic>
        </div>
      </OneRegistryLayout>
    );
  }
}

export default Form3Route;
